import { render, staticRenderFns } from "./ArmadiettoComponent.vue?vue&type=template&id=6b9323ad&"
import script from "./ArmadiettoComponent.vue?vue&type=script&lang=js&"
export * from "./ArmadiettoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports